module.exports = __webpack_public_path__ + "img/ad_1.c5ecacee.png";